import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from './Avatar.js';
import { Badge } from '../primitives/Badge.js';
import { Icon } from '../primitives/Icon.js';
import { TypingIndicator } from './TypingIndicator.js';
import { formatListTimestamp, previewForKind } from '../util/format.js';
export function ChatListItem({ chat, title, avatarUrl, presence, active = false, typing, onClick, onContextMenu, }) {
    const { myState, lastMessage } = chat;
    const row = {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-3)',
        padding: 'var(--space-2) var(--space-3)',
        width: '100%',
        border: 'none',
        textAlign: 'left',
        cursor: 'pointer',
        background: active ? 'var(--color-surface-hover)' : 'transparent',
        color: 'var(--color-text)',
        minHeight: '60px',
    };
    const handleContext = (e) => {
        if (!onContextMenu)
            return;
        e.preventDefault();
        onContextMenu({ x: e.clientX, y: e.clientY });
    };
    const previewText = typing && typing.users.length > 0
        ? null
        : lastMessage
            ? previewForKind(lastMessage.kind, lastMessage.preview)
            : '';
    return (_jsxs("button", { type: "button", "data-chat-item": "", "data-active": active ? '' : undefined, "data-pinned": myState.pinned ? '' : undefined, "data-muted": myState.muted ? '' : undefined, style: row, onClick: onClick, onContextMenu: handleContext, children: [_jsx(Avatar, { name: title, src: avatarUrl, size: 48, online: presence === 'online', colorKey: chat.id }), _jsxs("span", { style: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '2px' }, children: [_jsxs("span", { style: { display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }, children: [_jsx("span", { "data-chat-title": "", style: {
                                    flex: 1,
                                    minWidth: 0,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    fontSize: 'var(--font-lg)',
                                    fontWeight: 'var(--weight-semibold)',
                                }, children: title }), myState.pinned ? (_jsx(Icon, { name: "pin", size: 14, title: "\u0417\u0430\u043A\u0440\u0435\u043F\u043B\u0451\u043D", style: { color: 'var(--color-text-muted)' } })) : null, myState.muted ? (_jsx(Icon, { name: "mute", size: 14, title: "\u0411\u0435\u0437 \u0437\u0432\u0443\u043A\u0430", style: { color: 'var(--color-text-muted)' } })) : null, lastMessage ? (_jsx("span", { "data-chat-time": "", style: {
                                    fontSize: 'var(--font-xs)',
                                    color: 'var(--color-text-muted)',
                                    flex: '0 0 auto',
                                }, children: formatListTimestamp(lastMessage.createdAt) })) : null] }), _jsxs("span", { style: { display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }, children: [_jsx("span", { style: { flex: 1, minWidth: 0 }, children: previewText !== null ? (_jsx("span", { "data-chat-preview": "", style: {
                                        display: 'block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        fontSize: 'var(--font-sm)',
                                        color: 'var(--color-text-muted)',
                                    }, children: previewText })) : (_jsx(TypingIndicator, { users: typing.users, kind: typing.kind })) }), _jsx(Badge, { count: myState.unreadCount, muted: myState.muted })] })] })] }));
}
//# sourceMappingURL=ChatListItem.js.map